import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
export const companyBusinessTypeEnum = createEnum({
    SUPPLIER: ['supplier', '供应商', 'blue'],
    PURCHASER: ['purchaser', '采购公司', 'green'],
    SELF: ['self', '自主公司', 'lime'],
    CHANNEL: ['channel', '通道公司', 'cyan'],
    DOMESTIC_PARTNER: ['domestic_partner', '内贸合作公司', 'geekblue'],
    LOGISTICS: ['logistics', '物流承运公司', 'orange'],
    WAREHOUSE: ['warehouse', '仓储公司', 'purple'],
    CUSTOMS: ['customs', '报关公司', 'geekblue'],
    GUARANTEE: ['guarantee', '担保公司', 'gold'],
    DELIVERY: ['delivery', '交车公司', 'magenta'],
    PICKUP: ['pickup', '提货公司', 'volcano'],
});
export const COMPANY_BUSINESS_TYPES = enumValues(companyBusinessTypeEnum);
export const COMPANY_BUSINESS_TYPE_LABEL_MAP = enumLabelMap(companyBusinessTypeEnum);
export const companyAccountCategoryEnum = createEnum({
    PUBLIC: ['public', '对公', 'blue'],
    PERSONAL: ['personal', '对私', 'orange'],
});
export const COMPANY_ACCOUNT_CATEGORIES = enumValues(companyAccountCategoryEnum);
export const COMPANY_ACCOUNT_CATEGORY_LABEL_MAP = enumLabelMap(companyAccountCategoryEnum);
export const companyCategoryEnum = createEnum({
    SUPPLIER: ['supplier', '供应商', 'blue'],
    SELF: ['self', '自营', 'green'],
    CHANNEL: ['channel', '通道商', 'cyan'],
    LOGISTICS: ['logistics', '物流商', 'orange'],
    WAREHOUSE: ['warehouse', '仓储商', 'purple'],
});
export const COMPANY_CATEGORIES = enumValues(companyCategoryEnum);
export const COMPANY_CATEGORY_LABEL_MAP = enumLabelMap(companyCategoryEnum);
export const cooperationStatusEnum = createEnum({
    NEGOTIATING: ['negotiating', '洽谈中', 'gold'],
    COOPERATING: ['cooperating', '合作中', 'green'],
    SUSPENDED: ['suspended', '已暂停', 'orange'],
    TERMINATED: ['terminated', '已终止', 'red'],
});
export const COOPERATION_STATUSES = enumValues(cooperationStatusEnum);
export const COOPERATION_STATUS_LABEL_MAP = enumLabelMap(cooperationStatusEnum);
export const settlementMethodEnum = createEnum({
    PREPAID: ['prepaid', '预付'],
    CASH: ['cash', '现结'],
    MONTHLY_30: ['monthly_30', '月结30天'],
    MONTHLY_60: ['monthly_60', '月结60天'],
    OTHER: ['other', '其他'],
});
export const SETTLEMENT_METHODS = enumValues(settlementMethodEnum);
export const SETTLEMENT_METHOD_LABEL_MAP = enumLabelMap(settlementMethodEnum);
export const companyTypeEnum = createEnum({
    LIMITED: ['有限责任公司', '有限责任公司'],
    STOCK: ['股份有限公司', '股份有限公司'],
    INDIVIDUAL: ['个体工商户', '个体工商户'],
    FOREIGN: ['外资企业', '外资企业'],
    OTHER: ['其他', '其他'],
});
export const COMPANY_TYPES = enumValues(companyTypeEnum);
export const COMPANY_TYPE_LABEL_MAP = enumLabelMap(companyTypeEnum);
export const taxpayerTypeEnum = createEnum({
    GENERAL: ['一般纳税人', '一般纳税人'],
    SMALL: ['小规模纳税人', '小规模纳税人'],
    NON_VAT: ['非增值税纳税人', '非增值税纳税人'],
});
export const TAXPAYER_TYPES = enumValues(taxpayerTypeEnum);
export const TAXPAYER_TYPE_LABEL_MAP = enumLabelMap(taxpayerTypeEnum);
export const accountNatureEnum = createEnum({
    PUBLIC: ['公', '对公', 'blue'],
    PRIVATE: ['私', '对私', 'orange'],
});
export const ACCOUNT_NATURES = enumValues(accountNatureEnum);
export const ACCOUNT_NATURE_LABEL_MAP = enumLabelMap(accountNatureEnum);
export const currencyEnum = createEnum({
    CNY: ['CNY', '人民币(CNY)'],
    CNH: ['CNH', '离岸人民币(CNH)'],
    USD: ['USD', '美元(USD)'],
    EUR: ['EUR', '欧元(EUR)'],
    HKD: ['HKD', '港币(HKD)'],
    OTHER: ['其他', '其他'],
});
export const CURRENCIES = enumValues(currencyEnum);
export const CURRENCY_LABEL_MAP = enumLabelMap(currencyEnum);
export const invoiceTypeEnum = createEnum({
    VAT_SPECIAL: ['vat_special', '增值税专用发票', 'red'],
    VAT_NORMAL: ['vat_normal', '增值税普通发票', 'blue'],
    E_NORMAL: ['e_normal', '电子普通发票', 'cyan'],
    E_SPECIAL: ['e_special', '电子专用发票', 'purple'],
});
export const INVOICE_TYPES = enumValues(invoiceTypeEnum);
export const INVOICE_TYPE_LABEL_MAP = enumLabelMap(invoiceTypeEnum);
export const invoiceTaxpayerTypeEnum = createEnum({
    GENERAL: ['一般纳税人', '一般纳税人'],
    SMALL: ['小规模纳税人', '小规模纳税人'],
});
export const INVOICE_TAXPAYER_TYPES = enumValues(invoiceTaxpayerTypeEnum);
export const INVOICE_TAXPAYER_TYPE_LABEL_MAP = enumLabelMap(invoiceTaxpayerTypeEnum);
//# sourceMappingURL=company.js.map